import * as types from '../types';

export function addProject(name) {
    return {
        type: types.ADD_PROJECT,
        name
    };
}
export function toggleMenu(state) {
    return {
        type: types.TOGGLE_MENU,
        state
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/index.js